
import { Component, Vue } from "vue-property-decorator";
import { getTotalPrintCount } from "@/api/print";
import { formatThousands } from "@/utils/index.js"

@Component({
  name: "Form2"
})
export default class extends Vue {
  mounted() {
    this.GetTotalCount();
  }
  private totalcount = "0";
  private GetTotalCount() {
    // this.totalcount = obj_HttpRequest_Core.getTotalPrintCount();
    var printTotalNumResponseStr = getTotalPrintCount();
    var printTotalNumResJson = JSON.parse(printTotalNumResponseStr);
    if (printTotalNumResJson.respcode === "000") {
      this.totalcount = printTotalNumResJson.data;
    } else {
      this.totalcount = "0";
    }

    this.$nextTick(() => {
      const container: any = document.querySelector(".label-total-count-p");
      const node: any = document.querySelector(".__total_count__");
      if (!container || !node) {
        return;
      }

      if (container.clientWidth < node.clientWidth) {
        node.style = `transform: scale(${container.clientWidth / node.clientWidth})`
      } else {
        node.style = "transform: none"
      }
    })
  }

  private format(num) {
    return formatThousands(num);
  }
}
